import * as React from 'react';
import { render } from 'react-dom';
import { ReactMultiEmail } from 'react-multi-email';
import 'react-multi-email/style.css';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendInvites } from '../../redux/actions/profileActions';
import {history} from '../../routers/AppRouter';
import {ONBOARDING} from '../../constants/routes';


const FormInvite = ({step, setStep}) => {
  const [invitees, setInvitees] = useState([]);
  const [note, setNote] = useState();

  const dispatch = useDispatch();

  const invite = () => {
    if(!invitees.length){
      alert('Please specify who you\'d like to invite to your regrestry.')
    }
    if(note){
      dispatch(sendInvites({ invitees, note }));
    } else alert('Please include a note.')
  };

  return (
    <>
      <div className="invite-container">
        <h3 className="invite-titles">Please enter the email addresses you'd like to invite.</h3>
        <ReactMultiEmail
          style={{ minHeight: '100px' }}
          placeholder="Enter Email Address"
          emails={invitees}
          onChange={(_emails) => {
            setInvitees(_emails);
          }}
          getLabel={(email, index, removeEmail) => (
            <div data-tag key={index} style={{ fontSize: '1rem', backgroundColor: '#ffc56d' }}>
              {email}
              <span data-tag-handle onClick={() => removeEmail(index)}>
                ×
              </span>
            </div>
          )}
        />
      </div>
      <div className="note-container">
        <h3 className="invite-titles">Write a note to send the people you'd like to invite to your registry.</h3>
        <p>New apartment? Lost all your shoes in the breakup? Just need to treat yourself? Tell us what these funds + items are going toward!</p>
        <textarea
          style={{
            width: '100%',
            backgroundColor: 'white',
            padding: '10px',
            fontWeight: '500',
            fontSize: '14px'
          }}
          rows={5}
          onChange={(event)=>setNote(event.target.value.replace(/(?:\r\n|\r|\n)/g, '<br />'))}
        />
      </div>
      <div className="onboard-button-wrapper invite-buttons-container">
        <button
          type="button"
          className="onboard-button"
          color="primary"
          onClick={step ? () => setStep(4) : () => history.push(ONBOARDING)}
        >
          {step ? 'Back' : 'Account Setup'}
        </button>
        <button
          type="button"
          disabled={!invitees.length}
          className={!invitees.length ? 'disabled-onboard-button onboard-button' : 'onboard-button'}
          color="primary"
          onClick={invite}
        >
          Send Invites
        </button>
      </div>
    </>
  );
};

export default FormInvite;
